import { render, staticRenderFns } from "./TerritoryV2.vue?vue&type=template&id=39239559"
import script from "./TerritoryV2.vue?vue&type=script&lang=js"
export * from "./TerritoryV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports